/**
 * Shared styles for cube manage-cubes operation forms (Trim, Clone, Add,
 * Rename, Copy, Time Travel, Export). Used by both the in-season manage
 * cubes page and the budget manage cubes page.
 */
import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { globalStyle, style } from "@vanilla-extract/css";

export const contextGrid = style({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: primitiveTokens.sizing["3x"],
  maxWidth: "1000px"
});

export const simpleFormContainer = style({
  maxWidth: "480px"
});

export const fieldGroup = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["1x"]
});

export const buttonRow = style({
  display: "flex",
  justifyContent: "flex-start",
  marginTop: primitiveTokens.sizing["2x"]
});

export const formColumn = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"]
});

export const hintText = style({
  fontSize: "13px",
  opacity: 0.7
});

export const narrowField = style({
  maxWidth: "320px"
});

export const newValuesSection = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["3x"],
  marginTop: primitiveTokens.sizing["2x"]
});

export const errorText = style({
  color: "var(--color-error)",
  fontSize: "13px"
});

/**
 * Single wrap-friendly row for Copy Year's "source of truth" picker
 * (producer / brand / source cube / years). Direct children share the
 * row evenly via ``flex: 1 1 200px`` so the row collapses into multiple
 * lines when the panel is narrow without any per-child wiring.
 */
export const copyRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["3x"],
  flexWrap: "wrap"
});

globalStyle(`${copyRow} > *`, {
  flex: "1 1 200px",
  minWidth: "180px"
});

/**
 * Wrapper for Copy Year's Target-side field. A subtle left border
 * separates the "from" half of the row (source producer/cube/year) from
 * the "to" half (target year), reinforcing the source → target read.
 */
export const copyRowTargetField = style({
  borderLeft: `1px solid ${semanticThemeTokens.divider.backgroundColor}`,
  paddingLeft: primitiveTokens.sizing["4x"]
});

export const inlineRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["3x"]
});

export const offsetRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["3x"],
  alignItems: "flex-end"
});

export const flexItem = style({
  flex: 1
});

export const pollingContainer = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: primitiveTokens.sizing["3x"],
  padding: primitiveTokens.sizing["6x"]
});
